import { googlePlayLink, itunesLink } from "../../constants/links"

import AppStoreBtnEN from "../../images/app-store-en.svg"
import AppStoreBtnES from "../../images/app-store.svg"
import GooglePlayBtnEN from "../../images/google-play-en.svg"
import GooglePlayBtnES from "../../images/google-play.svg"
import Img from "gatsby-image/withIEPolyfill"
import React from "react"
import styles from "./hero-home-content.module.css"
import { useTranslation } from "react-i18next"

export default function HeroHomeContent({
  phoneImage,
  title,
  text,
  downloadTitle,
}) {
  const { i18n } = useTranslation()

  let AppStoreBtn = AppStoreBtnEN
  let GooglePlayBtn = GooglePlayBtnEN

  if (i18n.language === "es") {
    AppStoreBtn = AppStoreBtnES
    GooglePlayBtn = GooglePlayBtnES
  }

  return (
    <div className={styles.heroContent}>
      <Img
        fluid={phoneImage}
        objectFit="cover"
        objectPosition="50% 50%"
        alt="Puma FastPay App Mobile"
        className={styles.heroContentImg}
      />
      <div className={styles.heroContentIntro}>
        <div className={styles.heroContentInfo}>
          <h2 id="hero-title" className={styles.heroContentInfoTitle}>
            {title}
          </h2>
          <h3 id="hero-text" className={styles.heroContentInfoText}>
            {text}
          </h3>
        </div>
        <div className={styles.heroContentDownload}>
          <h3 id="hero-download" className={styles.heroContentDownloadTitle}>
            {downloadTitle}
          </h3>
          <nav className={styles.heroContentDownloadButtons}>
            <a
              href={itunesLink}
              className={`${styles.heroContentDownloadButtonsButton} ${styles.heroContentDownloadButtonsButtonApple}`}
            >
              <img
                src={AppStoreBtn}
                alt="Puma FastPay App Store"
                className={styles.heroContentDownloadButtonsButtonImg}
              />
            </a>
            <a
              href={googlePlayLink}
              className={`${styles.heroContentDownloadButtonsButton} ${styles.heroContentDownloadButtonsButtonGoogle}`}
            >
              <img
                src={GooglePlayBtn}
                alt="Puma FastPay Google Play"
                className={styles.heroContentDownloadButtonsButtonImg}
              />
            </a>
          </nav>
        </div>
      </div>
    </div>
  )
}
